import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

const LOOK = {
  ok: { dot: "bg-emerald-500", ring: "bg-emerald-400", label: "Bot Telegram aktif" },
  down: { dot: "bg-red-500", ring: "bg-red-400", label: "Bot Telegram bermasalah" },
  off: { dot: "bg-slate-300", ring: "", label: "Bot Telegram belum diatur" },
};

export function BotStatus() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/settings/telegram/health").then((r) => setS(r.data)).catch(() => setS({ status: "down", reason: "Status tidak dapat dicek" }));
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);
  if (!s) return null;
  const look = LOOK[s.status] || LOOK.down;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/settings" className="inline-flex items-center gap-2 border border-border rounded-sm px-3 py-1.5 text-xs font-medium hover:bg-secondary transition-colors"
            data-testid="bot-status" data-status={s.status}>
            <span className="relative flex h-2.5 w-2.5">
              {look.ring && <span className={`absolute inline-flex h-full w-full rounded-full ${look.ring} opacity-60 animate-ping`} />}
              <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${look.dot}`} />
            </span>
            <span data-testid="bot-status-label">{look.label}</span>
          </Link>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs" data-testid="bot-status-reason">
          {s.bot_username ? `@${s.bot_username} · ` : ""}{s.reason}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
